/**
 * Close codes the server sends when reconnecting cannot help: the upgrade was
 * refused (4001) or the transport's feature gate is off (4003). Retrying
 * either just burns the client's attempts against a door that stays shut.
 *
 * `4499` is deliberately NOT here. The server ages sockets out with it on
 * purpose and the reconnect is the whole mechanism, so a blanket "4xxx is
 * fatal" rule would silently kill the transport after the first age sweep.
 */
const TERMINAL_CLOSE_CODES = new Set([4001, 4003]);

/** True when a ws close should stop the client retrying. */
export function isTerminalClose(errOrCloseEvent: unknown): boolean {
  const code = (errOrCloseEvent as { code?: unknown } | null | undefined)?.code;
  return typeof code === 'number' && TERMINAL_CLOSE_CODES.has(code);
}
